import React from 'react'
import { Link } from 'react-router-dom'
import FilterList from '../../constants/plugins/FilterList'


function ItemHeader(props) {
  const { plugin, onSelect } = props

  return (
    <a href="#" className="link_thumb" onClick={onSelect}>
      <img src={plugin.image} width="280" height="126" className="thumb_img" style={{ display:'inline-block' }} />

      {plugin.active &&
        <span className="txt_status">
          <span className="screen_out">현재상태 : </span>
          사용중
        </span>
      }

      {!plugin.active && plugin.recommended &&
        <span className="txt_status txt_status_type1">추천</span>
      }
    </a>
  )
}

function ItemContent(props) {
  const { plugin, onSelect } = props

  return (
    <div className="desc_plugin">
      <strong className="tit_plugin txt_ellip">
        <a href="#" onClick={onSelect}>{plugin.title}</a>
      </strong>
      <span className="txt_plugin txt_vellip">{plugin.description}</span>

      <div className="bundle_tag">
        { plugin.pc && <Link className="link_tag" to={`/plugins/pc`}>#PC</Link> }
        { plugin.mobile && <Link className="link_tag" to={`/plugins/mobile`}>#모바일</Link> }

        { plugin.category.map(category => {
          let item = FilterList.find(filter => filter.category === category || (filter === "pc" && plugin.pc || (filter === "mobile" && plugin.mobile)))
          if (item && item.category !== 'recommand') {
            return (
              <Link key={category} className="link_tag" to={`/plugins/${item.category}`}>#{item.label}</Link>
            )
          }
        })}
      </div>
    </div>
  )
}

function PluginListItem(props) {
  const { plugin, onSelect } = props

  function handleSelect(e) {
    e.target.blur()
    e.preventDefault()
    onSelect(plugin)
  }

  return (
    <li>
      <ItemHeader plugin={plugin} onSelect={handleSelect} />
      <ItemContent plugin={plugin} onSelect={handleSelect} />
    </li>
  )
}

export default PluginListItem
